import { FunctionComponent } from 'react'

import { Provider } from 'react-redux'
import reduxStore from 'redux/store'
import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react' // Injects MUI emotion styles first so our utility classes can override them

import UserWrapper from './UserWrapper'
import LayoutWrapperComponent from './LayoutWrapperComponent'

const muiCache = createCache({ key: 'mui', prepend: true })

const LayoutWrapper: FunctionComponent = (props) => (
  <Provider store={reduxStore}>
    <CacheProvider value={muiCache}>
      <UserWrapper>
        <LayoutWrapperComponent {...props} />
      </UserWrapper>
    </CacheProvider>
  </Provider>
)

export default LayoutWrapper
